// extracted by mini-css-extract-plugin
export default {"inputAutocomplete":"BaseAddressForm_inputAutocomplete__AoOTf"};